module.exports = {
        srcSet: __webpack_public_path__ + "static/media/documents-and-pen-664.bb6ca820.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/documents-and-pen-664.bb6ca820.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/documents-and-pen-664.bb6ca820.webp",
        toString: function(){return __webpack_public_path__ + "static/media/documents-and-pen-664.bb6ca820.webp"},
        
        width: 664,
        height: 664
      }